// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_POST = "pridanie diskusie";
export const ACTION_TO_SEND_HEART = "zaslanie srdie\u010dka";
